import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { InstagramFeed } from '../../components'
import * as ROUTES from '../../utils/constants/routes'

export default class About extends Component {
    render() {
        return (
            <div>
                <section className="about-section about-page pt-180 pb-100">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="about-item">
                                    <span>
                                        <i className="flaticon-care-about-plants"></i>
                                About Us
                            </span>
                                    <h3>An international independent charity organisation</h3>
                                    <p className="main-color">
                                        Your support will help us to make life better living for poor vulnerable children
                                        consectetur adipisicing elit, sed do
                            </p>
                                    <p>
                                    Child hope international children ministries is a non-profit charity organization formed in 2009 in Uganda which focuses on children who are orphans, have single parents, are homeless, sexually abused, malnourished, living in abject poverty as they experience all the side effects of war and HIV/AIDS. 
                                    <br/>We take on the responsibility to educate, counsel, give medical support, feed children daily, provide clothing for some and hopefully in the future provide shelter where necessary. We also use this opportunity to teach them good moral values based on the word of God. 
                                    Every outreach to the communities we reach is done in a loving and caring environment that promotes hopefulness. 
                                    <br/>Please join our efforts to create real change and manifest our vision into reality.
                             {/* Please join our efforts to create real change and manifest our vision into reality. */}
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-image">
                                    <img src="./assets/img/about/1.jpg" className="shadow about-page-img" alt="About" />
                                    <img src="./assets/img/about/2.jpg" className="shadow" alt="About" />
                                </div>
                                <div className="about-video">
                                    <a href="https://www.youtube.com/watch?v=uemObN8_dcw" className="video-btn popup-youtube"
                                        savefrom_lm_index="0" savefrom_lm="1">
                                        <i className="bx bx-play"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="mission-section">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6 p-0">
                                <div className="mission-image">
                                    <img src="./assets/img/mission.png" alt="Mission" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mission-tab">
                                    <span>
                                        <i className="flaticon-target"></i>
                                Our mission
                            </span>
                                    <h2>Concern about Our Mission</h2>
                                    <div className="tab mission-list-tab">
                                        <ul className="tabs">
                                            <li>
                                                <a href="_">
                                                    Our Mission
                                        </a>
                                            </li>
                                            <li>
                                                <a href="_">
                                                    Our Vision
                                        </a>
                                            </li>
                                            <li>
                                                <a href="_">
                                                    Our Goal
                                        </a>
                                            </li>
                                        </ul>
                                        <div className="tab_content">
                                            <div className="tabs_item">
                                                <p>The organization envisions to eradicate poverty by providing the skill and knowledge to the under privileged children of the society and and to the needy refugees and orphans that are coming from war torn countries to reside in Uganda. </p>

                                                <p>They will be equipped to recognize and use resources around them for their holistic empowerment.</p>
                                                <a className="default-btn" href="_">
                                                    Our Mission
                                            <span></span>
                                                    <i className="flaticon-right"></i>
                                                </a>
                                            </div>

                                            <div className="tabs_item">
                                            <p>To see a healthy, stable, gender balanced, prosperous and productive society that living in a conducive environment. </p>
                                                  <a className="default-btn" href="_">
                                                    Our Mission
                                            <span></span>
                                                    <i className="flaticon-right"></i>
                                                </a>
                                            </div>

                                            <div className="tabs_item">
                                            <p>To identify, tap and optimally harness the potential of the under – privileged children of the city of Kampala and Uganda in such a way as to strike a judicious balance between their own quality of life as well as towards their meaningful contribution to the society/nation. </p>
                                                   <a className="default-btn" href="_">
                                                    Our Mission
                                            <span></span>
                                                    <i className="flaticon-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="team-section pt-100 pb-70">
                    <div className="container">
                        <div className="team-title-area">
                            <div className="row align-items-center">
                                <div className="col-lg-7">
                                    <div className="section-title text-left">
                                        <span>
                                            <i className="flaticon-support"></i>
                                    Meet Our Team
                                </span>
                                        <h2>Talented Team behind ChildHope</h2>
                                        <p>
                                        Meet our team of dedicated staff and International volunteers. Child Hope’s Senior Leadership Team, Volunteers and each and every staff member are dedicated to the belief that every child in Uganda and around the world deserves a future.

                                </p>
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                    <div className="team-btn text-right">
                                        <Link  to={ROUTES.TEAM} className="optional-btn">
                                            Meat Our Team
                                            <i className="flaticon-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="team-item">
                                    <div className="image">
                                        <img src="assets/img/team/james.jpg" alt="James Bwengye" />

                                        <ul className="social">
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-facebook"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-twitter"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-linkedin"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-instagram"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="content">
                                        <h3>James Bwengye</h3>
                                        <span>CEO & Founder</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="team-item">
                                    <div className="image">
                                        <img src="assets/img/team/jolly.jpg" alt="Jolly Bwengye" />

                                        <ul className="social">
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-facebook"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-twitter"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-linkedin"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-instagram"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="content">
                                        <h3>Jolly Bwengye</h3>
                                        <span>Manager</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="team-item">
                                    <div className="image">
                                        <img src="assets/img/team/sam.jpg" alt="Agaba Samuel" />

                                        <ul className="social">
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-facebook"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-twitter"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-linkedin"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank">
                                                    <i className="bx bxl-instagram"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="content">
                                        <h3>Agaba Samuel</h3>
                                        <span>Volunteer</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* 
                <section className="testimonials-section pb-100">
                    <div className="container">
                        <div className="section-title">
                            <span>
                                <i className="flaticon-testimonial"></i>
                        Testimonials
                    </span>
                            <h2>Don’t Believe Us? See review</h2>
                        </div>
                        <div className="feedback-slider owl-carousel owl-theme owl-loaded owl-drag">
                            <div className="owl-stage-outer">
                                <div className="owl-stage"
                                    style={{ transform: 'translate3d(-2280px, 0px, 0px)', transition: 'all 1s ease 0s', width: '4560px' }}>
                                    <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                        <div className="feedback-item">
                                            <div className="content">
                                                <h3>It’s just amazed us to be with you”</h3>
                                                <p>
                                                    Every works inton sit amet consectetur adipisicing elit, sed do eiusmod tempor
                                                    incididunt ut et dolore magna aliqua. Ut enim ad will not be does.
                                        </p>
                                                <div className="info">
                                                    <img src="/assets/img/client/1.jpg" alt="Morgan Ando" />
                                                    <h4>Morgan Ando</h4>
                                                    <span>Ustino Charity Canada</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                        <div className="feedback-item">
                                            <div className="content">
                                                <h3>Precious Journey with you”</h3>
                                                <p>
                                                    Every works inton sit amet consectetur adipisicing elit, sed do eiusmod tempor
                                                    incididunt ut et dolore magna aliqua. Ut enim ad will not be does.
                                        </p>
                                                <div className="info">
                                                    <img src="/assets/img/client/2.jpg" alt="Morgan Ando" />
                                                    <h4>Juhan Luis</h4>
                                                    <span>Charity Bingo UK</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                        <div className="feedback-item">
                                            <div className="content">
                                                <h3>It’s just amazed us to be with you”</h3>
                                                <p>
                                                    Every works inton sit amet consectetur adipisicing elit, sed do eiusmod tempor
                                                    incididunt ut et dolore magna aliqua. Ut enim ad will not be does.
                                        </p>
                                                <div className="info">
                                                    <img src="/assets/img/client/1.jpg" alt="Morgan Ando" />
                                                    <h4>Morgan Ando</h4>
                                                    <span>Ustino Charity Canada</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                        <div className="feedback-item">
                                            <div className="content">
                                                <h3>Precious Journey with you”</h3>
                                                <p>
                                                    Every works inton sit amet consectetur adipisicing elit, sed do eiusmod tempor
                                                    incididunt ut et dolore magna aliqua. Ut enim ad will not be does.
                                        </p>
                                                <div className="info">
                                                    <img src="/assets/img/client/2.jpg" alt="Morgan Ando" />
                                                    <h4>Juhan Luis</h4>
                                                    <span>Charity Bingo UK</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                        <div className="feedback-item">
                                            <div className="content">
                                                <h3>It’s just amazed us to be with you”</h3>
                                                <p>
                                                    Every works inton sit amet consectetur adipisicing elit, sed do eiusmod tempor
                                                    incididunt ut et dolore magna aliqua. Ut enim ad will not be does.
                                        </p>
                                                <div className="info">
                                                    <img src="/assets/img/client/1.jpg" alt="Morgan Ando" />
                                                    <h4>Morgan Ando</h4>
                                                    <span>Ustino Charity Canada</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                        <div className="feedback-item">
                                            <div className="content">
                                                <h3>Precious Journey with you”</h3>
                                                <p>
                                                    Every works inton sit amet consectetur adipisicing elit, sed do eiusmod tempor
                                                    incididunt ut et dolore magna aliqua. Ut enim ad will not be does.
                                        </p>
                                                <div className="info">
                                                    <img src="/assets/img/client/2.jpg" alt="Juhan Luis" />
                                                    <h4>Juhan Luis</h4>
                                                    <span>Charity Bingo UK</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                        <div className="feedback-item">
                                            <div className="content">
                                                <h3>It’s just amazed us to be with you”</h3>
                                                <p>
                                                    Every works inton sit amet consectetur adipisicing elit, sed do eiusmod tempor
                                                    incididunt ut et dolore magna aliqua. Ut enim ad will not be does.
                                        </p>
                                                <div className="info">
                                                    <img src="/assets/img/client/1.jpg" alt="Morgan Ando" />
                                                    <h4>Morgan Ando</h4>
                                                    <span>Ustino Charity Canada</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="owl-item" style={{ width: '540px', marginRight: '30px' }}>
                                        <div className="feedback-item">
                                            <div className="content">
                                                <h3>Precious Journey with you”</h3>
                                                <p>
                                                    Every works inton sit amet consectetur adipisicing elit, sed do eiusmod tempor
                                                    incididunt ut et dolore magna aliqua. Ut enim ad will not be does.
                                        </p>
                                                <div className="info">
                                                    <img src="/assets/img/client/2.jpg" alt="Juhan Luis" />
                                                    <h4>Juhan Luis</h4>
                                                    <span>Charity Bingo UK</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="owl-nav disabled">
                                <button type="button" role="presentation" className="owl-prev">
                                    <i className="flaticon-left"></i>
                                </button>
                                <button type="button" role="presentation" className="owl-next">
                                    <i className="flaticon-right"></i>
                                </button>
                            </div>
                            {/* <div className="owl-dots">
                        <button role="button" className="owl-dot">
                            <span></span>
                        </button>
                        <button role="button" className="owl-dot">
                            <span></span>
                        </button>
                    </div> 
                        </div>
                    </div>
                </section>  */}
                {/* <InstagramFeed/> */}
            </div>

        )
    }
}


